import React from 'react'

import { Item } from './style'

const ItemModal = ({ children, feedback }) => {
  return <Item feedback={feedback}>{children}</Item>
}

export default ItemModal
